import React from 'react';
import { Col, FloatingLabel, Form, Row, Table } from 'react-bootstrap';
import FilesRender from '../../../components/atoms/FilesRender';

const RecitalDetail = ({ step, form, handleChange, handleCheckbox, handleFileChange }) => {
  return (
    <Row>
      <Col xs={6}>
        <FloatingLabel controlId="floatingInput" label="Stamp Duty Amount" className="mb-3">
          <Form.Control
            required
            className="input"
            name="stampDutyAmount"
            value={form.stampDutyAmount}
            onChange={handleChange}
            type="number"
            placeholder="Stamp Duty Amount"
          />
        </FloatingLabel>
      </Col>
      <Col xs={6}>
        <FloatingLabel controlId="floatingInput" label="Agreement Executed Date" className="mb-3">
          <Form.Control
            required
            className="input"
            name="agreementExecutedDate"
            value={form.agreementExecutedDate}
            onChange={handleChange}
            type="date"
            placeholder="Agreement Executed Date"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Registration charges" className="mb-3">
          <Form.Control
            required
            className="input"
            name="registrationCharge"
            value={form.registrationCharge}
            onChange={handleChange}
            type="number"
            placeholder="Registration charges"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Other Charges" className="mb-3">
          <Form.Control
            required
            className="input"
            name="otherCharges"
            value={form.otherCharges}
            onChange={handleChange}
            type="number"
            placeholder="Other Charges"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Charges Remark" className="mb-3">
          <Form.Control
            required
            className="input"
            name="chargesRemark"
            value={form.chargesRemark}
            onChange={handleChange}
            type="text"
            placeholder="Charges Remark"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Floor" className="mb-3">
          <Form.Control
            required
            className="input"
            name="floor"
            value={form.floor}
            onChange={handleChange}
            type="text"
            placeholder="Floor"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Square Feet" className="mb-3">
          <Form.Control
            required
            className="input"
            name="squareFeet"
            value={form.squareFeet}
            onChange={handleChange}
            type="text"
            placeholder="Square Feet"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Power Deposit And Consumption" className="mb-3">
          <Form.Control
            required
            className="input"
            name="powerDepositAndConsumption"
            value={form.powerDepositAndConsumption}
            onChange={handleChange}
            type="text"
            placeholder="Power Deposit And Consumption"
          />
        </FloatingLabel>
      </Col>
      <Col xs={12}>
        <FloatingLabel controlId="floatingInput" label="Address" className="mb-3">
          <Form.Control
            required
            as="textarea"
            className="input"
            name="address"
            value={form.address}
            onChange={handleChange}
            type="text"
            placeholder="Address"
            style={{ height: '80px' }}
          />
        </FloatingLabel>
      </Col>
      <Col xs={12}>
        <FloatingLabel controlId="floatingInput" label="Purpose" className="mb-3">
          <Form.Control
            required
            as="textarea"
            className="input"
            name="purpose"
            value={form.purpose}
            onChange={handleChange}
            type="text"
            placeholder="Purpose"
            style={{ height: '80px' }}
          />
        </FloatingLabel>
      </Col>
      <Col xs={6}>
        <FloatingLabel controlId="floatingInput" label="Effective Date" className="mb-3">
          <Form.Control
            required
            disabled={step === 4 && form?.AgreementIncrementDetails && form?.AgreementIncrementDetails.length > 0}
            className="input"
            name="effectiveDate"
            value={form.effectiveDate}
            onChange={handleChange}
            type="date"
            placeholder="Effective Date"
          />
        </FloatingLabel>
      </Col>
      <Col xs={6}>
        <FloatingLabel controlId="floatingInput" label="Agreement End Date" className="mb-3">
          <Form.Control
            required
            disabled={step === 4 && form?.AgreementIncrementDetails && form?.AgreementIncrementDetails.length > 0}
            className="input"
            name="agreementEndDate"
            value={form.agreementEndDate}
            onChange={handleChange}
            type="date"
            placeholder="Agreement End Date"
          />
        </FloatingLabel>
      </Col>
      <Row className="mb-3">
        <Col xs={12} className="blockLine my-3">
          <p className="my-0">
            <strong>GST</strong>
          </p>
          <hr className="my-0" />
        </Col>
        <Col xs={3} className="warranty-btn">
          <span>Under GST?</span>
          <input
            className="react-switch-checkbox"
            id={`react-switch-new`}
            type="checkbox"
            onChange={handleCheckbox}
            checked={form.underGst}
            name="underGst"
          />
          <label className="react-switch-label" htmlFor={`react-switch-new`}>
            <span className="no">NO</span>
            <span className={`react-switch-button`} />
            <span className="yes">YES</span>
          </label>
        </Col>
        {form.underGst && (
          <>
            <Col xs={3} className="mt-3">
              <FloatingLabel controlId="floatingInput" label="GST Number">
                <Form.Control
                  className="input"
                  name="gstNumber"
                  value={form.gstNumber}
                  onChange={handleChange}
                  type="text"
                  placeholder="GST Number"
                />
              </FloatingLabel>
            </Col>
            <Col xs={3} className="mt-3">
              <FloatingLabel controlId="floatingInput" label="GST Rate" className="mb-3">
                <Form.Select className="input" value={form.gstRate} name="gstRate" onChange={handleChange} required>
                  <option value="">Select GST Rate</option>
                  <option value="0">0%</option>
                  <option value="5">5%</option>
                  <option value="10">10%</option>
                  <option value="12">12%</option>
                  <option value="18">18%</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col xs={3} className="mt-3">
              <FloatingLabel controlId="floatingInput" label="With GST Rent/Lease Amount">
                <Form.Control
                  disabled
                  className="input"
                  name="withGstRentAmount"
                  value={form.withGstRentAmount}
                  onChange={handleChange}
                  type="text"
                  placeholder="GST Number"
                />
              </FloatingLabel>
            </Col>
          </>
        )}
      </Row>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Rent/Lease Amount" className="mb-3">
          <Form.Control
            required
            className="input"
            name="rentOrLeaseAmount"
            value={form.rentOrLeaseAmount}
            onChange={handleChange}
            type="number"
            placeholder="Rent/Lease Amount"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Security Deposit Amount" className="mb-3">
          <Form.Control
            required
            className="input"
            name="securityDepositAmount"
            value={form.securityDepositAmount}
            onChange={handleChange}
            type="number"
            placeholder="Security Deposit Amount"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <Form.Label>Upload Agreement</Form.Label>
        <Form.Control
          className="input mb-3"
          multiple
          name="agreementFiles"
          onChange={handleFileChange}
          type="file"
          required
          autoComplete="false"
        />
        {FilesRender(form['agreementFiles'])}
      </Col>
      <Col xs={12} className="mb-3">
        {Array.isArray(form.OwnerDetails) && form.OwnerDetails.length > 0 ? (
          <div className="card-body vehicle-requests-table">
            <Table responsive striped bordered>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Owner</th>
                  <th>Share in %</th>
                  <th>Without GST</th>
                  <th>With GST</th>
                </tr>
              </thead>
              <tbody>
                {form.OwnerDetails.map((owner, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{owner?.ownerName}</td>
                      <td>{owner?.rentShareInPercent} %</td>
                      <td>{((owner?.rentShareInPercent / 100) * form.rentOrLeaseAmount).toFixed(2) || 0}</td>
                      <td>{((owner?.rentShareInPercent / 100) * form.withGstRentAmount).toFixed(2) || 0}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        ) : (
          <span className="text-danger">No Owner Details Added Yet</span>
        )}
      </Col>
      <Col xs={12}>
        <FloatingLabel controlId="floatingInput" label="Security Deposit Payment Details" className="mb-3">
          <Form.Control
            required
            as="textarea"
            className="input"
            name="securityDepositPaymentDetails"
            value={form.securityDepositPaymentDetails}
            onChange={handleChange}
            type="text"
            placeholder="Security Deposit Payment Details"
            style={{ height: '80px' }}
          />
        </FloatingLabel>
      </Col>
      <Col xs={12}>
        <FloatingLabel controlId="floatingInput" label="Security Deposit T&C" className="mb-3">
          <Form.Control
            required
            as="textarea"
            className="input"
            name="securityDepositTc"
            value={form.securityDepositTc}
            onChange={handleChange}
            type="text"
            placeholder="Security Deposit T&C"
            style={{ height: '80px' }}
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Lock-In Period (Years)" className="mb-3">
          <Form.Control
            required
            className="input"
            name="lockInPeriodInYears"
            value={form.lockInPeriodInYears}
            onChange={handleChange}
            type="text"
            placeholder="Lock-In Period (Years)"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Maintenance Charges" className="mb-3">
          <Form.Control
            required
            className="input"
            name="maintenanceCharges"
            value={form.maintenanceCharges}
            onChange={handleChange}
            type="number"
            placeholder="Maintenance Charges"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Water Charges" className="mb-3">
          <Form.Control
            required
            className="input"
            name="waterCharges"
            value={form.waterCharges}
            onChange={handleChange}
            type="number"
            placeholder="Water Charges"
          />
        </FloatingLabel>
      </Col>
      <Col xs={12}>
        <FloatingLabel controlId="floatingInput" label="Lock-In Period T&C" className="mb-3">
          <Form.Control
            required
            as="textarea"
            className="input"
            name="lockInPeriodTc"
            value={form.lockInPeriodTc}
            onChange={handleChange}
            type="text"
            placeholder="Lock-In Period T&C"
            style={{ height: '80px' }}
          />
        </FloatingLabel>
      </Col>
    </Row>
  );
};

export default RecitalDetail;
